import React from 'react'
import { StyledInput } from './style'

type Props = {
  name?: string
  value: string
  placeholder?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const TextInput = ({ name, value, onChange, placeholder }: Props) => {
  return (
    <StyledInput
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={100}
    />
  )
}

export default TextInput
